import { render, staticRenderFns } from "./LogisticCostList.vue?vue&type=template&id=ee7b0de8&scoped=true"
import script from "./LogisticCostList.vue?vue&type=script&lang=js"
export * from "./LogisticCostList.vue?vue&type=script&lang=js"
import style0 from "./LogisticCostList.vue?vue&type=style&index=0&id=ee7b0de8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee7b0de8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee7b0de8')) {
      api.createRecord('ee7b0de8', component.options)
    } else {
      api.reload('ee7b0de8', component.options)
    }
    module.hot.accept("./LogisticCostList.vue?vue&type=template&id=ee7b0de8&scoped=true", function () {
      api.rerender('ee7b0de8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shipping/LogisticCostList.vue"
export default component.exports